<template>
  <b-modal 
    title="Upload logo"
    v-model="showModal"
    @ok.prevent="submit()"
    :ok-disabled="sending || upload == null"
    @cancel.prevent="cancel"
    @hidden="cancel"
  >
    <b-form @submit.prevent>
      <div class="company">
        <img v-if="url || organization.logo" :src="url || organization.logo" class="logo img-fluid" alt="Respondent Organiztion Logo" />
      </div>
      <b-form-group
        label="Logo"
        label-for="org-logo-upload"
        invalid-feedback="Upload a file"
      >
        <b-form-file
          @change="onFileChange"
          v-model="upload"
          :state="errors.length == 0 ? null : upload != null"
        ></b-form-file>
      </b-form-group>
      <BaseMessageBlock :messages="errors"></BaseMessageBlock>
      <template v-slot:modal-ok >
        <div style="width: 36px;">
          <b-spinner v-if="sending" small label="Spinning"/>
          <div v-else>Add</div>
        </div>
      </template>
    </b-form>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  props: {
    organization: { type: Object, default: null }
  },
  data() {
    return {
      errors: [],
      showModal: false,
      sending: false,
      upload: null,
      url: ''
    }
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    submit() {
      this.errors = [];

      if (!this.validateForm()) {
        return;
      }

      this.sending = true;

      const file = this.upload;
      let request = new FormData();
      request.append("file", file);
      request.append("organizationId", this.organization.organizationId);
      request.append("fileName", file.name);
      request.append("contentType", file.type);

      axios
        .post(`${this.$api_url}/organizations/update`, request, this.getReqConfig({
          "Content-Type":"multipart/form-data"
        }))
        .then(response => {
          this.$emit("submit", response.data);
          this.cancel();
        })
        .catch(err => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.sending = false;
        });
    },
    cancel() {
      this.resetForm();
      this.hide();
    },
    //Pointless right now, but someday...
    validateForm(){
      const initErrors = this.errors.length;

      if (this.upload === []) {
        this.errors.push({ message: 'File missing' });
      }

      return initErrors === this.errors.length;
    },
    resetForm() {
      this.errors = [];
      this.url = "";
      this.upload = null;
      this.sending = false;
    },
    onFileChange(e) {
      if (e.target.files.length === 0) {
        return;
      }

      //Check if image
      const file = e.target.files[0];
      if(!this.isFileImage(file)) {
        this.errors.push('File uploaded must be an image');
        this.upload = null;
        return;
      }

      this.url = URL.createObjectURL(file);
    },
    isFileImage(file) {
      return file && file['type'].split('/')[0] === 'image';
    }
  }
}
</script>